import { hexToRgba } from '../../utils/color.js';

/**
 * Generates CSS for the onsite (popup/modal) survey layout.
 * Includes the overlay backdrop and positioned survey box.
 *
 * @param {object} style - The survey style configuration object.
 * @returns {string} CSS string for onsite layout.
 */
export function layoutOnsiteCSS(style) {
    const bgcolorRGBA = hexToRgba(
        style.overlayColor || '#000000',
        style.opacity != null ? style.opacity : 0.5
    );
    const showOverlay = style.showOverlay === true || style.showOverlay === '1';
    const blurBg = style.blurBackground === true || style.blurBackground === '1' ? '10px' : (style.blurBackground ?? 0 + 'px');

    const blurValue = showOverlay ? blurBg : '0px';
    const overlayBg = showOverlay ? bgcolorRGBA : 'transparent';

    /* Position calculations - these remain as template interpolation
       because they depend on dynamic style values */
    const topVal = style.verticalPosition === 'top'
        ? '32px'
        : style.verticalPosition === 'middle'
            ? '50%'
            : style.verticalPosition === 'bottom'
                ? 'auto'
                : 'auto';

    const bottomVal = style.verticalPosition === 'bottom' ? '32px' : 'auto';

    const leftVal = style.position === 'left'
        ? '32px'
        : style.position === 'middle'
            ? '50%'
            : style.position === 'right'
                ? 'auto'
                : 'auto';

    const rightVal = style.position === 'right' ? '32px' : 'auto';

    const transformVal = style.verticalPosition === 'middle' && style.position === 'middle'
        ? 'translate(-50%, -50%)'
        : style.verticalPosition === 'middle'
            ? 'translateY(-50%)'
            : style.position === 'middle'
                ? 'translateX(-50%)'
                : 'none';

    /* Mobile position helpers */
    const mobileRight = style.position === 'right' || style.position === 'middle' ? '0' : 'auto';
    const mobileLeft = style.position === 'left' || style.position === 'middle' ? '0' : 'auto';

    return `
    /* ===== Overlay / backdrop ===== */
    .ph-overlay {
        position: fixed;
        width: 100vw;
        height: 100dvh;
        backdrop-filter: blur(${blurValue});
        -webkit-backdrop-filter: blur(${blurValue});
        background-color: ${overlayBg};
        top: 0;
        left: 0;
        z-index: ${style.zIndex ?? 999999998} !important;
        right: 0;
        bottom: 0;
    }

    /* ===== Survey box (onsite positioned) ===== */
    .ph-survey {
        width: var(--ph-box-width);
        height: auto;
        display: block;
        background-color: var(--ph-bg-color);
        padding: 16px;
        border-radius: 8px;
        font-family: var(--ph-font-family);
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.24);
        position: fixed;
        z-index: ${style.zIndex ?? 999999999} !important;
        line-height: normal;
        box-sizing: border-box;
        color: var(--ph-text-color);

        top: ${topVal};
        bottom: ${bottomVal};
        left: ${leftVal};
        right: ${rightVal};
        transform: ${transformVal};
    }

    /* ===== Mobile responsive ===== */
    @media (max-width: 440px) {
        .ph-survey {
            border-radius: 16px 16px 0 0;
            width: 100%;
            bottom: 0;
            right: ${mobileRight};
            left: ${mobileLeft};
            top: unset;
            transform: none;
        }
    }`;
}
